import api from './api';

export const companyDocumentService = {
  // Get all company documents
  getCompanyDocuments: () => {
    return api.get('/company-documents');
  },

  // Upload company document
  uploadCompanyDocument: (formData) => {
    return api.post('/company-documents/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Delete company document
  deleteCompanyDocument: (id) => {
    return api.delete(`/company-documents/${id}`);
  },

  // Download company document
  downloadCompanyDocument: (id) => {
    return api.get(`/company-documents/${id}/download`, {
      responseType: 'blob',
    });
  },
};
